import React from "react";
import { Map } from "@shared/Map/Map";
import { cn } from "@shared/components/utils";

interface MapPaneProps {
	className?: string;
}

export const MapPane: React.FC<MapPaneProps> = (props) => {
	return (
		<div
			className={cn(
				"relative h-full overflow-hidden border border-border-base-200 bg-base-200 rounded-sm",
				props.className,
			)}
		>
			<Map />
		</div>
	);
};
